import React, { useCallback, useMemo, useEffect } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import {
  Select,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  Text,
  TEXT_VARIANT_ITALIC_LIGHT,
  Flex,
  FormElement
} from 'mailup-web-components'
import {
  selectState,
  smallGroupsLoadingState,
  smallGroupsState
} from 'Pages/QuickSend/recoil/state/state'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { initSmallGroup } from 'Pages/QuickSend/recoil/callbacks/callbacks'
import { StyledIcon } from '../InputRecipients/InputRecipients'

const StyledSelect = styled(Select)`
  .e-select__tray {
    max-height: 180px;
  }
`

const SelectGroup = () => {
  const intl = useIntl()

  const options = useRecoilValue(smallGroupsState)
  const { loading, loaded, error } = useRecoilValue(smallGroupsLoadingState)
  const [{ group }, setSelectState] = useRecoilState(selectState)
  const initSelectGroup = useRecoilCallback(initSmallGroup, [])

  const withNoGroupOrOpt = useMemo(() => {
    if (options.length === 0) {
      return []
    } else {
      return options
    }
  }, [options])

  const handleSelectChange = useCallback(e => {
    setSelectState(prev => ({
      ...prev,
      group: e
    }))
  })

  const getHint = () => {
    return (
      options.length !== 0 &&
      intl.formatMessage({
        id: 'Load.Common.NoResultChosen'
      })
    )
  }

  useEffect(() => {
    !loaded && initSelectGroup()
  }, [loaded])

  return (
    <>
      {!error && (
        <FormElement
          hint={intl.formatMessage({
            id: 'Load.QuickSend.SelectSmallGroupDescription'
          })}
        >
          <StyledSelect
            loading={loading}
            disabled={loading}
            value={group}
            searchable
            onChange={handleSelectChange}
            options={withNoGroupOrOpt}
            hint={getHint()}
            placeholder={intl.formatMessage({
              id: 'Load.QuickSend.SelectSmallGroupLabel'
            })}
          />
        </FormElement>
      )}
      {error && (
        <Flex margin='32px' columnGap='4px' height='24px' alignItems='flex-end'>
          <StyledIcon />
          <Text variant={TEXT_VARIANT_ITALIC_LIGHT} htmlElement='span'>
            {intl.formatMessage(
              {
                id: 'Load.MailupCommon.ErrorFetchingReload'
              },
              {
                link: chunks => (
                  <Link
                    onClick={initSelectGroup}
                    variant={LINK_VARIANT_EXTRALIGHT}
                  >
                    {chunks}
                  </Link>
                )
              }
            )}
          </Text>
        </Flex>
      )}
    </>
  )
}

export default SelectGroup
